import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { AggregationLogDownloadResponse } from '@/repositories/generated';

const response: AggregationLogDownloadResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['取引月', '付与_ボーナスバリュー', '付与_通常ポイント'],
    ['2023/11', '400', '0'],
    ['2023/12', '11063', '0'],
  ]),
};

export const aggregationLogDownload = http.get(
  createMockEndpoint('/aggregation/:id/download'),
  async () => {
    await delay(2000);
    return HttpResponse.json(response, { status: 200 });
  },
);
